// Forever Forward — drag rail
// Pointer-drag scrolling with momentum, a progress hairline, and a
// cursor-following DRAG label (pointer:fine only). Falls back to plain
// native scrolling on touch, keyboard and reduced motion.

(function () {
  function initRail(rail) {
    if (!rail || rail.dataset.ffRailReady === 'true') return;
    rail.dataset.ffRailReady = 'true';

    var track = rail.querySelector('[data-ff-rail-track]');
    var bar = rail.querySelector('[data-ff-rail-bar]');
    var cursor = rail.querySelector('[data-ff-rail-cursor]');
    if (!track) return;

    var fine = window.matchMedia('(pointer: fine)').matches;
    var down = false;
    var startX = 0;
    var startScroll = 0;
    var moved = 0;

    function updateProgress() {
      if (!bar) return;
      var max = track.scrollWidth - track.clientWidth;
      var pct = max > 0 ? (track.scrollLeft / max) * 100 : 0;
      bar.style.transform = 'scaleX(' + (pct / 100).toFixed(4) + ')';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();

    if (!fine) return;

    track.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      down = true;
      moved = 0;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
      track.classList.add('is-dragging');
    });

    track.addEventListener('pointermove', function (e) {
      if (cursor) {
        var r = rail.getBoundingClientRect();
        cursor.style.transform = 'translate3d(' + (e.clientX - r.left) + 'px,' + (e.clientY - r.top) + 'px,0)';
      }
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.abs(dx);
      track.scrollLeft = startScroll - dx;
    });

    function release(e) {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
    }

    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);

    // Suppress the click that ends a drag so cards don't navigate
    track.addEventListener('click', function (e) {
      if (moved > 6) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    if (cursor) {
      rail.addEventListener('pointerenter', function () { cursor.classList.add('is-visible'); });
      rail.addEventListener('pointerleave', function () { cursor.classList.remove('is-visible'); });
    }
  }

  function init() {
    document.querySelectorAll('[data-ff-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
